<template>
  <SectionWrapper sectionId="news">
    <SectionContainer>
      <Heading :titleImgSrc="headingData.img" :titleText="headingData.text" :leading="headingData.leading" :description="headingData.description" />
      <ContentContainer>
        <div class="news_link">
          <LinkText href="/news" color="#090831">view more→</LinkText>
        </div>
        <div  v-if="isMobile().phone" class="news_container">
            <hooper :settings="hooperSettings">
              <slide v-for="(news, index) in newsList" :key="index">
                <NewsCard
                    class="news_item"
                    :imgSrc="news['media:thumbnail']"
                    :title="news.title"
                    :link="news.link"
                    :publishIsoDate="news.isoDate"
                    :description="news.description" />
              </slide>
              <HooperNavigation slot="hooper-addons"></HooperNavigation>
              <HooperPagination slot="hooper-addons"></HooperPagination>
            </hooper>
        </div>
        <div v-else class="news_container">
          <NewsCard v-for="(news, index) in newsList" :key="index"
              class="news_item"
              :imgSrc="news['media:thumbnail']"
              :title="news.title"
              :link="news.link"
              :publishIsoDate="news.isoDate"
              :description="news.description" />
        </div>
      </ContentContainer>
    </SectionContainer>
  </SectionWrapper>
</template>

<script>
import Heading from '../atoms/Heading'
import SectionWrapper from '../atoms/SectionWrapper'
import SectionContainer from '../atoms/SectionContainer'
import ContentContainer from '../atoms/ContentContainer'
import NewsCard from '../atoms/NewsCard'
import LinkText from '../atoms/LinkText'
import { News as NewsFunction } from '../../functions/news'
import isMobile from 'ismobilejs'
import { Hooper, Slide, Pagination as HooperPagination, Navigation as HooperNavigation } from 'hooper'

export default {
  name: 'news',
  components: {
    Heading,
    SectionWrapper,
    SectionContainer,
    ContentContainer,
    NewsCard,
    LinkText,
    Hooper,
    Slide,
    HooperPagination,
    HooperNavigation
  },
  data () {
    return {
      headingData: {
        img: require('@/assets/images/title_news.svg'),
        text: 'news',
        leading: '最新情報',
        description: ''
      },
      newsList: [],
      isMobile,
      hooperSettings: {
        autoPlay: true,
        infiniteScroll: true,
        centerMode: true,
        wheelControl: false,
        playSpeed: 10000
      }
    }
  },
  async mounted () {
    const newsList = await NewsFunction.getAll()
    this.newsList = newsList.sort((a, b) => {
      if (a.isoDate === b.isoDate) return 0
      return a.isoDate > b.isoDate ? -1 : 1
    }).slice(0, 3)
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/stylesheets/variables';
@import '../../assets/stylesheets/mixins';

.news {
  &_container {
    display: flex;
    gap: 40px;
    @include bpOnlySp() {
      flex-direction: column;
    }
  }
  &_item {
    flex-grow: 1;
    min-width: 0;
    align-items: center;
    margin: 0 auto;
    &:not(:first-of-type) {
      @include bpOnlyPc() {
        // margin-left: 40px;
      }
      @include bpOnlySp() {
        margin-top: 48px;
      }
    }
  }
  &_link {
    @include bpOnlyPc() {
      font-size: 20px;
    }
    @include bpOnlySp() {
      font-size: 15px;
    }
    text-align: right;
    font-weight: bold;
    line-height: 1.4;
    letter-spacing: 0.1em;
    margin-bottom: 20px;
  }
}

.hooper {
  height: 100%;
}

</style>
